// extracted by mini-css-extract-plugin
export default {"page":"EngineeringPageLoading_page__719AL","label":"EngineeringPageLoading_label__q8ATF","dots":"EngineeringPageLoading_dots__cMlKM"};